import { api } from './client';

export async function fetchSiteSettings() {
  const { data } = await api.get('/v1/site-settings');
  return data;
}
